import axios from "axios";

export default function getAllOrder() {
  return axios.get("/order");
}
